import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ActionType } from '@editor/src/js/constants/common-action-type';

/**
 * 获取当前model所有的菜单属性对象
 * @param model
 */
export function getMenuValues(model: ISlideModel): { [key: string]: any } {
    return {
        [ActionType.FILLCOLOR]: model.getBackgroundFill?.().getFillInfo(),
    };
}

